// Add your custom JS here.

(function($) {
   


$(document).ready(function(){

     // for play youtube video
     if( $(".video-bg-player").length > 0 ){
        if ($(window).width() >= 1199) {
            const videoID = document.querySelector(".video-bg-player").getAttribute("data-video");
            const tag = document.createElement("script");
            const firstScriptTag = document.getElementsByTagName("script")[0];
            const videoOverlay = document.querySelector(".video-bg-overlay");
            const playerOptions = {
                autohide: 1,
                autoplay: 1,
                controls: 0,
                disablekb: 1,
                enablejsapi: 1,
                iv_load_policy: 3,
                loop: 1,
                modestbranding: 1,
                mute: 1,
                playlist: videoID,
                rel: 0,
                showinfo: 0
            };

            tag.src = "https://www.youtube.com/iframe_api";
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

            let ytPlayer;

            function onYouTubeIframeAPIReady() {
                ytPlayer = new YT.Player("yt-player", {
                    events: {
                        onReady: onPlayerReady,
                        onStateChange: onPlayerStateChange
                    },
                    height: "720",
                    playerVars: playerOptions,
                    width: "1280",
                    videoId: videoID
                });
            }

            function onPlayerReady(event) {
                event.target.playVideo();

                const videoDuration = event.target.getDuration();

                setInterval(function () {
                    const videoCurrentTime = event.target.getCurrentTime();
                    const timeDifference = videoDuration - videoCurrentTime;

                    if (2 > timeDifference > 0) {
                        event.target.seekTo(0);
                    }
                }, 1000);
            }

            function onPlayerStateChange(event) {
                if (event.data == YT.PlayerState.PLAYING) {
                    videoOverlay.classList.add("video-bg-overlay--fadeOut");
                }
            }
        }
    }

    // slick slider for recent projects
    $('.zslider-slick').slick({

        dots: false,
        arrows: false,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 3,
        centerMode: true,
        responsive: [{

                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },

            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },

            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                    
                }
            }
        ]

    });

    $('.rp-slick').slick({

        dots: false,
        arrows: true,
        infinite: true,
        speed: 300,
        slidesToShow: 3,
        slidesToScroll: 3,
        centerMode: true,
        responsive: [

            {
                breakpoint: 769,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: false,
                }
            },

            {
                breakpoint: 650,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                    
                }
            }
        ]

    });

    // tabs

    $('.srv-tab-col').click(function(e){
        e.preventDefault();
        // $this = $(this);
        $('.srv-tab-col, .srv-block-row').each(function () {
            $(this).removeClass('active show');                
        });
        $(this).addClass('active');
        let tabNumber = $(this).data('tab');
        $('.srv-block-row').each(function(){
            let tabContent = $(this).data('content');
            if( tabContent == tabNumber ){
                $(this).addClass('active show');
            }
        })
    });
 
    
});

})(jQuery);